import { Pathnames } from 'next-intl/routing'

// export const locales = ['en', 'zh', 'tw', 'ja', 'ko']
export const locales = ['en', 'zh', 'de']

export const localeNames: any = {
  en: 'English',
  zh: '简体中文',
  de: 'Deutsch',
  // tw: '繁體中文',
  // ja: '日本語',
  // ko: '한국어',
}

export const defaultLocale = 'en'

export const localePrefix = 'as-needed'

export const localeDetection =
  process.env.NEXT_PUBLIC_LOCALE_DETECTION === 'true'

export const pathnames = {
  '/': '/',
  '/privacy-policy': '/privacy-policy',
  '/terms-of-service': '/terms-of-service',
} satisfies Pathnames<typeof locales>
